import type { TourStep } from '@/components/ui/Tour';
import { ENTERPRISE_UPGRADE_TOUR_STEP_IDS } from './tour-constants';

function StepContent({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

export function getEnterpriseUpgradeTourSteps(): TourStep[] {
  return [
    {
      content: (
        <StepContent
          title="Accounting integrations"
          description="Sync lesson and membership payments to Xero or QuickBooks from Payments → Accounting. Connect once and reconcile automatically."
        />
      ),
      selectorId: ENTERPRISE_UPGRADE_TOUR_STEP_IDS.PAYMENTS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Unlimited administrators"
          description="Invite as many academy administrators as you need from Settings → Administrators. They can help manage lessons and students without accessing payments."
        />
      ),
      selectorId: ENTERPRISE_UPGRADE_TOUR_STEP_IDS.ACCOUNT_MENU,
      position: 'bottom',
    },
    {
      content: (
        <StepContent
          title="Higher SMS allowance"
          description="Enterprise includes 1,000 SMS segments per month. Review SMS settings and notification defaults in Academy settings."
        />
      ),
      selectorId: ENTERPRISE_UPGRADE_TOUR_STEP_IDS.ACADEMY_SETTINGS,
      position: 'right',
    },
  ];
}
